import { render, staticRenderFns } from "./offer-history.vue?vue&type=template&id=6f3b2ba1&scoped=true"
import script from "./offer-history.vue?vue&type=script&lang=js"
export * from "./offer-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b2ba1",
  null
  
)

export default component.exports